"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaddedIconTheme = exports.getViewBox = exports.getIconPixelSize = exports.ICON_SIZES = void 0;
var ICON_SIZES = exports.ICON_SIZES = ['xl', 'xl-minus', 'lg-plus', 'lg', 'lg-minus', 'md-plus', 'md', 'md-minus', 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'];
var ICON_PIXEL_SIZES = {
  xl: 48,
  'xl-minus': 42,
  'lg-plus': 36,
  lg: 32,
  'lg-minus': 28,
  'md-plus': 26,
  md: 24,
  'md-minus': 20,
  'sm-plus': 18,
  sm: 16,
  'sm-minus': 14,
  'xs-plus': 12,
  xs: 11
};
var PADDED_ICON_PIXEL_SIZES = {
  xl: 52,
  'xl-minus': 46,
  'lg-plus': 40,
  lg: 35,
  'lg-minus': 30,
  'md-plus': 28,
  md: 26,
  'md-minus': 22,
  'sm-plus': 20,
  sm: 18,
  'sm-minus': 16,
  'xs-plus': 14,
  xs: 12
};
var isPaddedIconTheme = exports.isPaddedIconTheme = function isPaddedIconTheme(theme) {
  return theme.indexOf('concur_') >= 0 || theme.indexOf('sap_fiori_3') >= 0;
};
var getIconPixelSize = exports.getIconPixelSize = function getIconPixelSize(size, theme) {
  return isPaddedIconTheme(theme) ? PADDED_ICON_PIXEL_SIZES[size] : ICON_PIXEL_SIZES[size];
};
var getViewBox = exports.getViewBox = function getViewBox(theme) {
  if (theme.indexOf('concur_') >= 0) {
    return '0 0 24 24';
  }
  if (theme.indexOf('sap_fiori_3') >= 0) {
    return '0 0 96 96';
  }
  return '0 0 24 24';
};